// Thin wrapper around gtag so call sites don't need to guard against the
// script being blocked (ad blockers, privacy extensions) or not yet loaded.
export function trackEvent(name, params = {}) {
  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    window.gtag('event', name, params);
  }
}
